import React, { useState, createContext } from 'react';
import { API } from 'aws-amplify';
import { useAuth } from './Auth';
import { useApiError } from './ApiErrorProvider';
import { error } from '../constants/bindings';
import { SearchYear, SdoMyRequest, SdoInfoTab, SearchDate, SdoMyRequestForm, SdoCalendar } from '../models/SdoInterface';
import { generateNextNMonths, getDateAndTimeFormat, getEasternTime } from '../helpers/dateHelpers';
import { useSdoApiError } from './SdoApiErrorProvider';


const sdoMyRequestDefault:any = [];
const sdoInfoTabDefaut: any = {};
const SdoMyRequestFormDefaut:any =[];
const sdoCalendarDefaut: any = {};
const SpecialDayOffContext = createContext({
  sdoMyRequestLoading: true,
  sdoMyRequestData: sdoMyRequestDefault as SdoMyRequest[],
  getSdoMyRequestData: (search: SearchYear) => {},
  sdoInfoTabLoading: true,
  sdoInfoTabData: sdoInfoTabDefaut as SdoInfoTab,
  getSdoInfoTabData: () => {},
  deleteSdoSubmission: (search: SearchDate) => {},
  sdoMyRequestFormData: SdoMyRequestFormDefaut as SdoMyRequestForm[],
  saveSdoMyRequestFormData: (requestedDates: SdoMyRequestForm) => {},
  saveSdoLoading: true,
  getSdoCalendarData: (sdoMonthYear) => {},
  sdoCalLoading: true,
  sdoCalendarData: sdoCalendarDefaut as SdoCalendar,
});


export const SpecialDayOffProvider = (props) => {
  const { user } = useAuth();
  const { setErrorCode } = useApiError();
  const { setSdoErrorCode } = useSdoApiError();
  const [sdoMyRequestLoading, setSdoMyRequestLoading] = useState(true);
  const [sdoMyRequestData, setSdoMyRequestData] = useState<SdoMyRequest[]>(sdoMyRequestDefault);
  const [sdoInfoTabLoading, setSdoInfoTabLoading] = useState(true);
  const [sdoCalLoading, setSdoCalLoading] = useState(true);
  const [sdoInfoTabData, setSdoInfoTabData] = useState<SdoInfoTab>(sdoInfoTabDefaut);
  const [sdoMyRequestFormData, setSdoMyRequestFormData] = useState<SdoMyRequestForm[]>(SdoMyRequestFormDefaut);
  const [saveSdoLoading, setsaveSdoLoading] = useState(true);
  const [sdoCalendarData, setSdoCalendarData] = useState<SdoCalendar>(sdoCalendarDefaut);

  const getSdoMyRequestData = async (search) => {
    if (!user) {
      return;
    }
    try {
      setSdoMyRequestLoading(true);
      const requestObject = {
        body: {
          ...search
        }
      };
      const sdoMyRequest = await API.post('crewlife', `/sdo/submission/retrieve`,requestObject);
      const sdoMyRequestData = sdoMyRequest.result.map((row, index) => ({ ...row, id: index + 1 }));
      const sortMyRequestData = sdoMyRequestData?.slice();
      sortMyRequestData?.sort((a,b)=>
          (new Date(b.requestedFromDt)).getTime() - (new Date(a.requestedFromDt)).getTime()
      )
      const sortMyRequestDataET = sortMyRequestData.map(req => ({
        ...req,
        requestedOn:getEasternTime(req.requestedOn),
        lastUpdatedOn:getEasternTime(req.lastUpdatedOn)
      }))
      setSdoMyRequestData(sortMyRequestDataET);
      setSdoMyRequestLoading(false);
    } catch (e: any) {
      setSdoMyRequestLoading(false);
      if (e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
    }
  };

  const getSdoInfoTabData = async () => {
    if (!user) {
      return;
    }
    try {
      setSdoInfoTabLoading(true);
      const yearForNextMonth = generateNextNMonths()[0].year;
      const requestObject = {
        body: {
          "year": yearForNextMonth
        }
      };
      const sdoInfoTab = await API.post('crewlife', `/sdo/settings/retrieve`, requestObject);
      setSdoInfoTabData({
        ...sdoInfoTab[0],
        submissionFromDt:getEasternTime(sdoInfoTab[0].submissionFromDt),
        submissionToDt:getEasternTime(sdoInfoTab[0].submissionToDt),
        submissionReplyDt:getEasternTime(sdoInfoTab[0].submissionReplyDt),
      });
      setSdoInfoTabLoading(false);
    } catch (e: any) {
      setSdoInfoTabLoading(false);
      if (e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
    }
  };

  const getSdoCalendarData = async (sdoMonthYear) => {
    if (!user) {
      return;
    }
    try {
      setSdoCalLoading(true);
      const requestObject = {
        body: sdoMonthYear

      };
      const sdoCal = await API.post('crewlife', `/sdo/submission/calendar`, requestObject);
      if(Object.keys(sdoCal).length){
        setSdoCalendarData(sdoCal);
        setSdoCalLoading(false);        
      }
      else{
        setSdoCalLoading(false);
        setErrorCode(error.DEFAULT);
      }      
    } catch (e: any) {
      setSdoCalLoading(false);
      if (e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
    }
  };

  const deleteSdoSubmission = async (search: SearchDate) => {
    if (!search || !user) {
      return;
    }
    try {
      setSdoMyRequestLoading(true);
      const requestObject = {
        body: {
          ...search
        }
      };
      await API.post('crewlife', '/sdo/submission/delete', requestObject);
      setSdoMyRequestLoading(false);
    } catch (e: any) {
      setSdoMyRequestLoading(false);
      if (e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
    } finally {
      setSdoMyRequestLoading(false);
    }
  };


  const saveSdoMyRequestFormData = async (sdoReqForm: SdoMyRequestForm) => {
    if (!user ||!sdoReqForm) {
      return;
    }
    try {
      setsaveSdoLoading(true);
      const currentSdoDateAndTime = getDateAndTimeFormat();
      const requestObject = {
        body: {
          "sdoYear": sdoReqForm.sdoYear,
          "sdoMonth": sdoReqForm.sdoMonth,
          "sdoFromDt": sdoReqForm.sdoFromDt,
          "sdoToDt": sdoReqForm.sdoToDt,
          "duration": sdoReqForm.duration,
          "createdOn": currentSdoDateAndTime,
          "remarks": sdoReqForm.remarks,
          "status": sdoReqForm.status,
          "sdoConflictReview": sdoReqForm.sdoConflictReview,
          "additionalQualifications": sdoReqForm.additionalQualifications,
          "transactionId": sdoReqForm.transactionId
        }
      }
      if(!sdoReqForm.transactionId){
        delete requestObject.body.transactionId;
      }
      const sdoMyRequestFormData = await API.post('crewlife', '/sdo/submission/save', requestObject);
      setSdoMyRequestFormData(sdoMyRequestFormData);
      setsaveSdoLoading(false);
      setSdoErrorCode(0);
    } catch (e: any) { 
      // const isOffline = !navigator.onLine;
      // const isNetworkError = !e.response && (e.message === 'Network Error' || e.code === 'ERR_NETWORK');

      // if (isOffline || isNetworkError) {
      //   console.log("Network Error");
      //   //setSdoErrorCode(error.NETWORK);
      //   //setErrorCode(error.NETWORK);
      // }         
      if (e.response?.status) setSdoErrorCode(e.response?.status);
      else setSdoErrorCode(error.DEFAULT);
      setsaveSdoLoading(false);
    } finally {
      setsaveSdoLoading(true);
    }
  };


  return (
    <SpecialDayOffContext.Provider
      value={{
        sdoMyRequestLoading,
        sdoMyRequestData,
        getSdoMyRequestData,
        sdoInfoTabLoading,
        sdoInfoTabData,
        getSdoInfoTabData,
        deleteSdoSubmission,
        sdoMyRequestFormData,
        saveSdoMyRequestFormData,
        saveSdoLoading,
        getSdoCalendarData,
        sdoCalLoading,
        sdoCalendarData
      }}>
      {props.children}
    </SpecialDayOffContext.Provider>
  );
};

export const useSpecialDayOffProvider = () => {
  return React.useContext(SpecialDayOffContext);
};

